import React from "react";
import ClipboardCopy from '@components/common/clipboard_copy/main';
import Tooltip from '@components/common/tooltip/main';

import './styles/org_color_asset_modal.scss';

const renderHex = (hex): JSX.Element => (
  <li>
    <div className="color-value">
      <span className="color-label">{bfTranslate('Hex')}:</span>
      <p>#{hex}</p>
    </div>
    <p className="s-copy-color">
      <ClipboardCopy textToCopy={`#${hex}`} check showFeedbackAsTooltip={false}>
        {bfTranslate('Copy Hex')}
      </ClipboardCopy>
    </p>
  </li>
);

const renderRGB = (assetDataString): JSX.Element => (
  <li>
    <div className="color-value">
      <span className="color-label">RGB:</span>
      <p>{assetDataString}</p>
    </div>
    <p className="s-copy-color">
      <ClipboardCopy textToCopy={assetDataString} check showFeedbackAsTooltip={false}>
        {bfTranslate('Copy RGB')}
      </ClipboardCopy>
    </p>
  </li>
);

const renderCMYK = (assetDataString): JSX.Element => (
  <li>
    <div className="color-value">
      <span className="color-label">CMYK:{' '}
        <Tooltip
          placement="right"
          tooltipContent={bfTranslate('Displayed color for CMYK is approximate. Consider printing CMYK color before finalizing CMYK color values.')}
          tooltipId="cmyk-view"
          type="light"
        >
          <span className="bff-warning" />
        </Tooltip>
      </span>
      <p>{assetDataString}</p>
    </div>
    <p className="s-copy-color">
      <ClipboardCopy textToCopy={assetDataString} check showFeedbackAsTooltip={false}>
        {bfTranslate('Copy CMYK')}
      </ClipboardCopy>
    </p>
  </li>
);


const renderPantone = (pantone, pantoneU): JSX.Element => (
  <ul>
    <li>
      <div className="color-value">
        <span className="color-label">{bfTranslate('Pantone')}:</span>
        <p>{pantone}</p>
      </div>
      <p className="s-copy-color  ">
        <ClipboardCopy textToCopy={pantone} showFeedbackAsTooltip={false}>
          {bfTranslate('Copy Pantone')}
        </ClipboardCopy>
      </p>
    </li>
    <li>
      <div className="color-value">
        <span className="color-label">{bfTranslate('Pantone')}:</span>
        <p>{pantoneU}</p>
      </div>
      <p className="s-copy-color">
        {!!pantoneU && (
          <>
            <ClipboardCopy textToCopy={pantoneU} showFeedbackAsTooltip={false}>
              {bfTranslate('Copy Pantone')}
            </ClipboardCopy>
          </>
        )}
      </p>
    </li>
  </ul>
);

const ColorDetails = ({ assetData }): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/camelcase
  const { b, c, g, hex, k, m, pantone, pantone_u, r, y } = assetData;

  return (
    <ul className="m-show-full-display-color color-list">
      {!!hex && renderHex(hex)}
      {!!r && !!g && !!b && renderRGB(`${r} / ${g} / ${b}`)}
      {!!c && !!m && !!y && !!k && renderCMYK(`${c} / ${m} / ${y} / ${k}`)}
      {!!pantone && renderPantone(pantone, pantone_u)}
    </ul>
  );
};

export default ColorDetails;
